export const description = {
  fontWeight: 400,
}
